import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import { HOST_API } from "../../config";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import VideoReactions from "../VideoReactions";
import logoImg from "../../assets/logo.png";

const flickerGrids = [
  [
    false, false, false, false, false, false, false, false,
    true, true, true, true, true, false, false, true,
    false, false, false, false, false, false, true, false,
    true, true, true, false, false, true, false, false,
    false, true, false, false, true, true, true, true,
    true, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    true, true, true, true, false, false, false, true,
    false, false, false, true, false, false, true, true,
    true, true, true, false, false, true, false, true,
    false, false, false, false, true, false, false, true,
    false, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    false, true, true, true, false, false, false, true,
    false, false, false, true, false, false, true, true,
    true, true, true, false, false, true, false, false,
    false, true, false, false, true, false, false, false,
    true, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    true, true, true, true, false, false, false, true,
    false, false, false, true, false, false, true, true,
    true, true, false, false, false, true, false, false,
    false, false, false, false, true, false, false, false,
    false, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    true, true, true, true, true, false, false, true,
    false, false, false, false, false, false, true, true,
    true, true, false, false, false, true, false, false,
    false, false, false, false, true, true, true, true,
    true, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    true, true, true, true, true, false, false, false,
    false, true, false, false, false, false, false, false,
    true, false, false, false, false, false, false, true,
    false, false, false, false, false, false, true, false,
    false, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    false, true, true, true, false, false, false, true,
    false, false, false, true, false, false, true, true,
    true, true, true, false, false, true, false, false,
    false, true, false, false, true, false, false, false,
    true, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    true, true, true, true, true, false, false, true,
    false, false, false, false, false, false, false, true,
    true, true, false, false, false, false, false, false,
    false, true, false, false, true, true, true, true,
    true, false, false, false, false, false, false, false,
    false,
  ],
  [
    false, false, false, false, false, false, false, false,
    true, false, false, true, false, false, false, true,
    false, true, false, false, false, false, true, true,
    true, false, false, false, false, true, false, false,
    true, false, false, false, true, false, false, true,
    false, false, false, false, false, false, false, false,
    false,
  ]
];

const FlickerSpinnerMini = ({ grids, onColor = "#f0591f", offColor = "rgba(255,255,255,0.2)", interval = 180 }) => {
  const [frameIdx, setFrameIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setFrameIdx((prev) => (prev + 1) % grids.length);
    }, interval);
    return () => clearInterval(timer);
  }, [grids, interval]);

  const currentFrame = grids[frameIdx] || [];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 5px)',
      gridTemplateRows: 'repeat(7, 5px)',
      gap: '3px',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      {currentFrame.map((dotVal, idx) => (
        <div
          key={idx}
          style={{
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            background: dotVal ? onColor : offColor,
            boxShadow: dotVal ? `0 0 6px ${onColor}` : 'none',
            transition: 'background-color 0.15s ease, box-shadow 0.15s ease'
          }}
        />
      ))}
    </div>
  );
};

const IntroVideoSlider = () => {
  const [freelancers, setFreelancers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [selectedFreelancer, setSelectedFreelancer] = useState(null);
  const [selectedDescription, setSelectedDescription] = useState(null);

  const social3DStyle = {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '0.62rem',
    textDecoration: 'none',
    boxShadow: '0 3px 6px rgba(0,0,0,0.2), inset 0 1px 1px rgba(255,255,255,0.3)',
    transition: 'all 0.2s ease',
    cursor: 'pointer'
  };

  const applyHoverStyle = (target) => {
    target.style.transform = 'scale(1.2) translateY(-2px)';
    target.style.boxShadow = '0 5px 10px rgba(240, 89, 31, 0.3)';
  };

  const applyNormalStyle = (target) => {
    target.style.transform = 'scale(1) translateY(0)';
    target.style.boxShadow = '0 3px 6px rgba(0,0,0,0.2), inset 0 1px 1px rgba(255,255,255,0.3)';
  };

  useEffect(() => {
    fetchFreelancers();
  }, []);

  const fetchFreelancers = async () => {
    try {
      const res = await axios.get(`${HOST_API}meetfreelancers`);
      if (res.data.success) {
        setFreelancers(res.data.data);
        // Trigger auto card view increment
        res.data.data.forEach(freelancer => {
          handleCardView(freelancer.id);
        });
      }
    } catch (error) {
      console.error("Error fetching intro videos", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCardView = async (videoId) => {
    const viewedCardKey = `viewed_card_${videoId}`;
    if (sessionStorage.getItem(viewedCardKey)) return;
    
    try {
      const res = await axios.post(`${HOST_API}user/video/${videoId}/view`, { type: 'card' });
      if (res.data.success) {
        sessionStorage.setItem(viewedCardKey, "true");
        setFreelancers(prev => prev.map(f => f.id === videoId ? { ...f, views: res.data.views } : f));
      }
    } catch (err) {
      console.error("Error updating card view", err);
    }
  };

  const handleVideoPlay = async (videoId) => {
    const viewedKey = `viewed_video_${videoId}`;
    if (sessionStorage.getItem(viewedKey)) return;
    
    try {
      const res = await axios.post(`${HOST_API}user/video/${videoId}/view`, { type: 'play' });
      if (res.data.success) {
        sessionStorage.setItem(viewedKey, "true");
        setFreelancers(prev => prev.map(f => f.id === videoId ? { ...f, views: res.data.views } : f));
      }
    } catch (err) {
      console.error("Error updating views", err);
    }
  };

  const handleLike = async (videoId, type) => {
    const freelancer = freelancers.find(f => f.id === videoId);
    const hasLiked = freelancer?.user_liked?.[type] || false;
    const action = hasLiked ? "decrement" : "increment";
    
    try {
      const res = await axios.post(`${HOST_API}user/video/${videoId}/like`, { type, action });
      if (res.data.success) {
        setFreelancers(prev => prev.map(f => {
          if (f.id === videoId) {
            return {
              ...f,
              likes: res.data.likes,
              user_liked: {
                ...f.user_liked,
                [type]: !hasLiked
              }
            };
          }
          return f;
        }));
      }
    } catch (err) {
      console.error("Error updating likes", err);
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  if (loading || freelancers.length === 0) return null;

  return (
    <div style={{ background: "#020617", padding: "60px 0", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
      <div className="container">
        <div className="d-flex justify-content-between align-items-end mb-4 flex-wrap gap-3">
          <div>
            {/* Glowing tag */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'rgba(240, 89, 31, 0.08)', border: '1px solid rgba(240, 89, 31, 0.2)', padding: '4px 12px', borderRadius: '30px', marginBottom: '10px' }}>
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#f0591f', display: 'inline-block' }}></span>
              <span style={{ fontSize: '0.68rem', fontWeight: 600, color: '#f0591f', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Top Talent Showcase</span>
            </div>
            
            <h2 style={{ fontWeight: 800, color: "#fff", margin: "0 0 8px", fontSize: "2.2rem", letterSpacing: "-0.02em" }}>
              Meet Our <span style={{ color: "#f0591f" }}>Freelancers</span>
            </h2>
            <p style={{ color: "#94a3b8", margin: 0, fontSize: "clamp(0.9rem, 1.3vw, 1.05rem)" }}>Watch introduction videos and hire the best talent for your needs.</p>
          </div>
          <button 
            className="btn"
            style={{ 
              background: "#bf360c", 
              color: "white", 
              fontWeight: 600, 
              borderRadius: "10px", 
              padding: "10px 24px", 
              border: "none",
              boxShadow: "0 4px 15px rgba(216, 67, 21, 0.4)",
              transition: "all 0.2s",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px"
            }}
            onClick={() => navigate("/meet-freelancers")}
            onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.03)"}
            onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
          >
            View All Videos <i className="bi bi-arrow-right-short" style={{ fontSize: "1.2rem", marginTop: "-1px" }}></i>
          </button>
        </div>

        <Slider {...settings} className="intro-video-slider">
          {freelancers.map((freelancer, idx) => (
            <div key={idx} className="px-2">
              <div 
                style={{
                  background: "#020617",
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: "1px solid rgba(255,255,255,0.08)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  transition: "box-shadow 0.3s",
                }}
              >
                {/* Video Section */}
                <div 
                  onClick={() => {
                    setSelectedFreelancer(freelancer);
                    handleVideoPlay(freelancer.id);
                  }}
                  style={{ position: "relative", width: "100%", aspectRatio: "16/9", background: "#000", borderBottom: "1px solid rgba(255,255,255,0.08)", cursor: "pointer", overflow: "hidden" }}
                >
                  <video 
                    src={freelancer.video_link} 
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", opacity: 0.65 }}
                    muted
                    playsInline
                    preload="none"
                    poster={freelancer.profile_image}
                  />
                  {/* Premium Blur Overlay Layer with PowerPoint Slide Animations */}
                  <div style={{ 
                      position: 'absolute', 
                      top: 0, 
                      left: 0, 
                      width: '100%', 
                      height: '100%', 
                      background: 'rgba(2, 6, 23, 0.65)', 
                      backdropFilter: 'blur(8px)', 
                      zIndex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      padding: '16px'
                  }}>
                      {/* Center: "Meet [Logo]" row */}
                      <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          gap: '8px'
                      }}>
                          <span style={{
                              fontSize: '1.2rem',
                              fontWeight: 800,
                              color: '#f0591f',
                              textTransform: 'uppercase',
                              letterSpacing: '0.05em',
                              fontFamily: "'Sora', sans-serif",
                              animation: 'slideInMeet 6s cubic-bezier(0.16, 1, 0.3, 1) infinite'
                          }}>
                              Meet
                          </span>
                          <img 
                              src={logoImg} 
                              alt="Logo" 
                              style={{
                                  maxHeight: '38px',
                                  maxWidth: '150px',
                                  objectFit: 'contain',
                                  animation: 'slideInLogo 6s cubic-bezier(0.16, 1, 0.3, 1) infinite'
                              }}
                          />
                      </div>

                      {/* Bottom: Subtitle / tagline sliding up */}
                      <span style={{
                          fontSize: '0.68rem',
                          fontWeight: 700,
                          color: 'rgba(255, 255, 255, 0.8)',
                          textAlign: 'center',
                          letterSpacing: '0.04em',
                          textTransform: 'uppercase',
                          fontFamily: "'Sora', sans-serif",
                          animation: 'slideUpTagline 6s cubic-bezier(0.16, 1, 0.3, 1) infinite'
                      }}>
                          Pakistan's #1 Freelance Marketplace
                      </span>
                  </div>                  {/* Play Button Overlay on the bottom-right */}
                  <div style={{ position: 'absolute', bottom: '10px', right: '10px', width: '32px', height: '32px', borderRadius: '50%', background: 'rgba(240, 89, 31, 0.95)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)', color: '#fff', fontSize: '1rem', zIndex: 2 }}>
                    <i className="bi bi-play-fill" style={{ marginLeft: '1.5px', marginTop: '0.5px' }}></i>
                  </div>
                </div>

                {/* Details Section */}
                <div style={{ padding: "10px", flexGrow: 1, display: "flex", flexDirection: "column" }}>
                  {/* Profile Block: Flex row with Avatar and Info */}
                  <div 
                    onClick={() => navigate(`/profileOtherPerson/${freelancer.user_name}`)}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '8px' }}
                  >
                    <div style={{ width: '32px', height: '32px', borderRadius: '50%', overflow: 'hidden', background: '#1e293b', border: '1px solid #f0591f', flexShrink: 0 }}>
                      <img src={freelancer.profile_image} alt={freelancer.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <h3 style={{ margin: '0 0 1px', fontWeight: 600, fontSize: '0.8rem', color: '#fff', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {freelancer.name}
                        <i className="bi bi-patch-check-fill text-primary" style={{ fontSize: '0.72rem' }} title="Verified Expert"></i>
                      </h3>
                      <p style={{ margin: '0', fontSize: '0.65rem', color: '#f0591f', fontWeight: 500 }}>@{freelancer.user_name}</p>
                    </div>
                  </div>

                   <h4 style={{ margin: '0 0 3px', fontWeight: 600, color: '#f8fafc', fontSize: '0.8rem', lineHeight: 1.25, display: 'flex', alignItems: 'center', gap: '4px', wordBreak: 'break-word' }} title={freelancer.title}>
                     {freelancer.title}
                   </h4>
                  
                  <div style={{ fontSize: "0.72rem", color: "#cbd5e1", lineHeight: "1.25", minHeight: "32px", marginBottom: "6px", wordBreak: "break-word" }}>
                    {freelancer.description && freelancer.description.length > 120 ? (
                      <>
                        {freelancer.description.slice(0, 110)}...{' '}
                        <span 
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedDescription({
                              title: freelancer.title,
                              name: freelancer.name,
                              desc: freelancer.description
                            });
                          }}
                          style={{ 
                            color: '#f0591f', 
                            cursor: 'pointer', 
                            fontWeight: '600', 
                            textDecoration: 'underline',
                            marginLeft: '4px'
                          }}
                        >
                          Read More
                        </span>
                      </>
                    ) : (
                      freelancer.description
                    )}
                  </div>

                  {/* Category, Skills & Hashtags Badges */}
                  {(freelancer.category || freelancer.skills?.length > 0 || freelancer.hashtags?.length > 0) && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '6px' }}>
                      {freelancer.category && (
                        <div style={{ display: 'flex' }}>
                          <span style={{ 
                            fontSize: '0.62rem', 
                            padding: '2px 6px', 
                            background: 'rgba(240, 89, 31, 0.08)', 
                            color: '#f0591f', 
                            border: '1px solid rgba(240, 89, 31, 0.25)', 
                            borderRadius: '6px', 
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            letterSpacing: '0.03em',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}>
                            <i className="bi bi-folder2-open" style={{ fontSize: '0.7rem' }}></i>
                            {freelancer.category}
                          </span>
                        </div>
                      )}
                      {(freelancer.skills?.length > 0 || freelancer.hashtags?.length > 0) && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                          {freelancer.skills?.slice(0, 3).map((skill, sIdx) => {
                            const colors = [
                              { bg: 'rgba(249, 115, 22, 0.08)', text: '#fb923c', border: 'rgba(249, 115, 22, 0.2)' }, // orange
                              { bg: 'rgba(16, 185, 129, 0.08)', text: '#34d399', border: 'rgba(16, 185, 129, 0.2)' }, // green
                              { bg: 'rgba(139, 92, 246, 0.08)', text: '#a78bfa', border: 'rgba(139, 92, 246, 0.2)' }, // purple
                              { bg: 'rgba(59, 130, 246, 0.08)', text: '#60a5fa', border: 'rgba(59, 130, 246, 0.2)' }, // blue
                              { bg: 'rgba(236, 72, 153, 0.08)', text: '#f472b6', border: 'rgba(236, 72, 153, 0.2)' }, // pink
                              { bg: 'rgba(20, 184, 166, 0.08)', text: '#2dd4bf', border: 'rgba(20, 184, 166, 0.2)' }  // teal
                            ];
                            const color = colors[sIdx % colors.length];
                            return (
                              <span key={sIdx} style={{ 
                                fontSize: '0.6rem', 
                                padding: '2px 6px', 
                                background: color.bg, 
                                color: color.text, 
                                borderRadius: '8px', 
                                border: `1px solid ${color.border}`,
                                fontWeight: 500,
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '3px'
                              }}>
                                <span style={{ display: 'inline-block', width: '3px', height: '3px', borderRadius: '50%', background: color.text }}></span>
                                {skill}
                              </span>
                            );
                          })}
                          {freelancer.hashtags?.slice(0, 8).map((tag, hIdx) => {
                            const colors = [
                              { bg: 'rgba(56, 189, 248, 0.08)', text: '#38bdf8', border: 'rgba(56, 189, 248, 0.2)' }, // sky blue
                              { bg: 'rgba(168, 85, 247, 0.08)', text: '#a855f7', border: 'rgba(168, 85, 247, 0.2)' } // purple-ish
                            ];
                            const color = colors[hIdx % colors.length];
                            return (
                              <span key={hIdx} style={{ 
                                fontSize: '0.6rem', 
                                padding: '2px 6px', 
                                background: color.bg, 
                                color: color.text, 
                                borderRadius: '8px', 
                                border: `1px solid ${color.border}`,
                                fontWeight: 500,
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '3px'
                              }}>
                                <i className="bi bi-hash" style={{ fontSize: '0.7rem', marginLeft: '-2px' }}></i>
                                {tag}
                              </span>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Social Links & Views Footer Row */}
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginTop: 'auto', 
                    paddingTop: '8px', 
                    borderTop: '1px solid rgba(255,255,255,0.06)',
                    marginBottom: '14px'
                  }}>
                    {/* Left: Views */}
                    <span style={{ fontSize: '0.65rem', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 500 }}>
                      <i className="bi bi-eye-fill" style={{ color: '#f0591f' }}></i> {freelancer.views} Views
                    </span>

                    {/* Right: Watch on Social Media */}
                    {(freelancer.instagram_link || freelancer.facebook_link || freelancer.linkedin_link || freelancer.whatsapp_link || freelancer.tiktok_link || freelancer.youtube_link) ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span style={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 600, letterSpacing: '0.02em', textTransform: 'uppercase' }}>Watch on:</span>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          {freelancer.instagram_link && (
                            <a 
                              href={freelancer.instagram_link} 
                              target="_blank" 
                              rel="noreferrer" 
                              aria-label="Instagram Video"
                              style={{ ...social3DStyle, background: 'linear-gradient(45deg, #f09433 0%, #dc2743 50%, #bc1888 100%)' }}
                              onMouseOver={(e) => applyHoverStyle(e.currentTarget)}
                              onMouseOut={(e) => applyNormalStyle(e.currentTarget)}
                            >
                              <i className="bi bi-instagram" style={{ fontSize: '0.6rem' }}></i>
                            </a>
                          )}
                          {freelancer.facebook_link && (
                            <a 
                              href={freelancer.facebook_link} 
                              target="_blank" 
                              rel="noreferrer" 
                              aria-label="Facebook Video"
                              style={{ ...social3DStyle, background: 'linear-gradient(135deg, #1877f2 0%, #0056b3 100%)' }}
                              onMouseOver={(e) => applyHoverStyle(e.currentTarget)}
                              onMouseOut={(e) => applyNormalStyle(e.currentTarget)}
                            >
                              <i className="bi bi-facebook" style={{ fontSize: '0.6rem' }}></i>
                            </a>
                          )}
                          {freelancer.linkedin_link && (
                            <a 
                              href={freelancer.linkedin_link} 
                              target="_blank" 
                              rel="noreferrer" 
                              aria-label="LinkedIn Video"
                              style={{ ...social3DStyle, background: 'linear-gradient(135deg, #0077b5 0%, #004b73 100%)' }}
                              onMouseOver={(e) => applyHoverStyle(e.currentTarget)}
                              onMouseOut={(e) => applyNormalStyle(e.currentTarget)}
                            >
                              <i className="bi bi-linkedin" style={{ fontSize: '0.6rem' }}></i>
                            </a>
                          )}
                          {freelancer.whatsapp_link && (
                            <a 
                              href={freelancer.whatsapp_link} 
                              target="_blank" 
                              rel="noreferrer" 
                              aria-label="WhatsApp Video"
                              style={{ ...social3DStyle, background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)' }}
                              onMouseOver={(e) => applyHoverStyle(e.currentTarget)}
                              onMouseOut={(e) => applyNormalStyle(e.currentTarget)}
                            >
                              <i className="bi bi-whatsapp" style={{ fontSize: '0.6rem' }}></i>
                            </a>
                          )}
                          {freelancer.tiktok_link && (
                            <a 
                              href={freelancer.tiktok_link} 
                              target="_blank" 
                              rel="noreferrer" 
                              aria-label="TikTok Video"
                              style={{ ...social3DStyle, background: 'linear-gradient(135deg, #010101 0%, #00f2fe 50%, #fe0979 100%)' }}
                              onMouseOver={(e) => applyHoverStyle(e.currentTarget)}
                              onMouseOut={(e) => applyNormalStyle(e.currentTarget)}
                            >
                              <i className="bi bi-tiktok" style={{ fontSize: '0.6rem' }}></i>
                            </a>
                          )}
                          {freelancer.youtube_link && (
                            <a 
                              href={freelancer.youtube_link} 
                              target="_blank" 
                              rel="noreferrer" 
                              aria-label="YouTube Video"
                              style={{ ...social3DStyle, background: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)' }}
                              onMouseOver={(e) => applyHoverStyle(e.currentTarget)}
                              onMouseOut={(e) => applyNormalStyle(e.currentTarget)}
                            >
                              <i className="bi bi-youtube" style={{ fontSize: '0.6rem' }}></i>
                            </a>
                          )}
                        </div>
                      </div>
                    ) : (
                      <span style={{ fontSize: '0.65rem', color: '#94a3b8', fontStyle: 'italic' }}>GrapeTask Verified</span>
                    )}
                  </div>

                  {/* Likes */}
                  <VideoReactions 
                    freelancer={freelancer} 
                    onLike={handleLike} 
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>

        <style>{`
          .intro-video-slider .slick-prev, .intro-video-slider .slick-next {
            width: 40px;
            height: 40px;
            background: white;
            border-radius: 50%;
            box-shadow: 0 4px 10px rgba(0,0,0,0.1);
            z-index: 1;
          }
          .intro-video-slider .slick-prev { left: -15px; }
          .intro-video-slider .slick-next { right: -15px; }
          .intro-video-slider .slick-prev:before, .intro-video-slider .slick-next:before {
            color: #f0591f;
            font-size: 20px;
          }
          .intro-video-slider .slick-slide { padding: 15px 0; }
        `}</style>
      </div>

      {/* iOS-Style Video Player Modal */}
      {selectedFreelancer && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(2, 6, 23, 0.85)',
          backdropFilter: 'blur(20px)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          animation: 'fadeIn 0.25s ease forwards'
        }}>
          <div style={{
            background: '#090d16',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '24px',
            width: '100%',
            maxWidth: '960px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            position: 'relative',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
          }}>
            {/* Close button */}
            <button 
              onClick={() => setSelectedFreelancer(null)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s',
                zIndex: 10
              }}
              onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
            >
              <i className="bi bi-x-lg"></i>
            </button>

            <div className="row g-0" style={{ height: '100%' }}>
              {/* Video Side */}
              <div className="col-12 col-md-7" style={{ background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', aspectRatio: '16/9' }}>
                <video 
                  src={selectedFreelancer.video_link} 
                  controls
                  autoPlay
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </div>

              {/* Details Side */}
              <div className="col-12 col-md-5 d-flex flex-column" style={{ maxHeight: '90vh', overflowY: 'auto', padding: '24px', borderLeft: '1px solid rgba(255,255,255,0.06)' }}>
                {/* Profile Header */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                  <img src={selectedFreelancer.profile_image} alt={selectedFreelancer.name} style={{ width: '48px', height: '48px', borderRadius: '50%', border: '1.5px solid #f0591f', objectFit: 'cover' }} />
                  <div>
                    <h4 style={{ margin: 0, fontWeight: 700, fontSize: '1.1rem', color: '#fff', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      {selectedFreelancer.name}
                      <i className="bi bi-patch-check-fill text-primary" style={{ fontSize: '0.9rem' }}></i>
                    </h4>
                    <span style={{ fontSize: '0.8rem', color: '#f0591f', fontWeight: 500 }}>@{selectedFreelancer.user_name}</span>
                  </div>
                </div>

                <h5 style={{ fontWeight: 700, color: '#f8fafc', fontSize: '1.05rem', marginBottom: '10px' }}>{selectedFreelancer.title}</h5>
                <p style={{ fontSize: '0.85rem', color: '#cbd5e1', lineHeight: '1.6', marginBottom: '16px' }}>{selectedFreelancer.description}</p>

                {/* Badges */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '16px' }}>
                  {selectedFreelancer.category && (
                    <span style={{ fontSize: '0.75rem', padding: '4px 10px', background: 'rgba(59, 130, 246, 0.1)', color: '#60a5fa', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '6px' }}>
                      {selectedFreelancer.category}
                    </span>
                  )}
                  <span style={{ fontSize: '0.75rem', padding: '4px 10px', background: 'rgba(240, 89, 31, 0.1)', color: '#f0591f', border: '1px solid rgba(240, 89, 31, 0.2)', borderRadius: '6px' }}>
                    <i className="bi bi-eye-fill me-1"></i> {selectedFreelancer.views} Views
                  </span>
                </div>

                {/* Skills */}
                {selectedFreelancer.skills?.length > 0 && (
                  <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ fontSize: '0.8rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', marginBottom: '8px' }}>Skills</h6>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                      {selectedFreelancer.skills.map((skill, sIdx) => (
                        <span key={sIdx} style={{ fontSize: '0.7rem', padding: '4px 10px', background: 'rgba(255,255,255,0.04)', color: '#cbd5e1', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.06)' }}>
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                <div style={{ marginTop: 'auto', display: 'flex', gap: '10px' }}>
                  <button 
                    onClick={() => {
                      window.open(`/profileOtherPerson/${selectedFreelancer.user_name}`, "_blank");
                      setSelectedFreelancer(null);
                    }}
                    style={{
                      flex: 1,
                      padding: '10px',
                      background: '#f0591f',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#fff',
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      cursor: 'pointer'
                    }}
                  >
                    View Full Profile
                  </button>
                </div>
              </div>
            </div>
          </div>
          <style>{`
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes slideInMeet {
              0% { transform: translateX(-50px); opacity: 0; }
              8% { transform: translateX(0); opacity: 1; }
              85% { transform: translateX(0); opacity: 1; }
              93% { transform: translateX(-30px); opacity: 0; }
              100% { transform: translateX(-30px); opacity: 0; }
            }
            @keyframes slideInLogo {
              0% { transform: translateX(50px); opacity: 0; }
              8% { transform: translateX(0); opacity: 1; }
              85% { transform: translateX(0); opacity: 1; }
              93% { transform: translateX(30px); opacity: 0; }
              100% { transform: translateX(30px); opacity: 0; }
            }
            @keyframes slideUpTagline {
              0% { transform: translateY(30px); opacity: 0; }
              8% { transform: translateY(0); opacity: 1; }
              85% { transform: translateY(0); opacity: 1; }
              93% { transform: translateY(20px); opacity: 0; }
              100% { transform: translateY(20px); opacity: 0; }
            }

          `}</style>
        </div>
      )}
      {/* Premium Description Modal */}
      {selectedDescription && (
        <div 
          onClick={() => setSelectedDescription(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(2, 6, 17, 0.85)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px',
            animation: 'fadeIn 0.3s ease-out'
          }}
        >
          <div 
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#0f172a',
              border: '1px solid rgba(240, 89, 31, 0.3)',
              borderRadius: '20px',
              padding: '28px',
              maxWidth: '550px',
              width: '100%',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5), 0 0 15px rgba(240, 89, 31, 0.15)',
              position: 'relative',
              animation: 'fadeIn 0.3s ease-out'
            }}
          >
            {/* Close Button */}
            <button 
              onClick={() => setSelectedDescription(null)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'transparent',
                border: 'none',
                color: '#94a3b8',
                fontSize: '24px',
                cursor: 'pointer',
                transition: 'color 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = '#94a3b8'; e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              &times;
            </button>

            {/* Header info */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
              <span style={{ fontSize: '1.2rem' }}>🎥</span>
              <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '700', color: '#f0591f' }}>
                {selectedDescription.name}'s Introduction
              </h4>
            </div>

            <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#ffffff', marginBottom: '16px', lineHeight: '1.3' }}>
              {selectedDescription.title}
            </h3>

            <div 
              style={{ 
                maxHeight: '300px', 
                overflowY: 'auto', 
                color: '#cbd5e1', 
                fontSize: '0.85rem', 
                lineHeight: '1.6',
                textAlign: 'justify',
                paddingRight: '8px',
                whiteSpace: 'pre-line'
              }}
            >
              {selectedDescription.desc}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
              <button 
                onClick={() => setSelectedDescription(null)}
                style={{
                  backgroundColor: '#f0591f',
                  color: '#ffffff',
                  border: 'none',
                  padding: '8px 24px',
                  borderRadius: '10px',
                  fontWeight: '600',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(240, 89, 31, 0.3)',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#d44917'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#f0591f'; }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IntroVideoSlider;
